import Dexie from 'dexie';

const dexie = new Dexie("AllMyTunesOffline");

dexie.version(3).stores({
  tunes: 'id, title, recordings',
  sets: 'id, title',
  sessions: 'id, location, startedAt, endedAt',
  files: 'id',
  pendingWrites: '++id, collection, docId, type',
  preferences: 'id'
});

dexie.version(4).stores({
  tunes: 'id, title, recordings',
  sets: 'id, title',
  sessions: 'id, location, startedAt, endedAt',
  files: 'id',
  pendingWrites: '++id, collection, docId, type',
  preferences: 'id',
  profiles: 'uid'
});

export default dexie;
